import React from "react";
import { HeroProductsStatic } from '../../components';
import { Banner, BannerTech } from '../../components';
import { Loader } from '../../components';
import { NumbersWrap } from '../../components';
import { NumbersRowSingle } from '../../components';
import { NumberCell } from '../../components';
import { VideoScrollAlone } from '../../components';
import { useSelector } from "react-redux";


const ProductsVCommerceContainer = (props) => {
  const loader = useSelector((state) => state.loader);

  const imgHero = require('../../assets/hero-solutions/hero-v-commerce.jpg');
  document.title = "V-Commerce by Invrsion";
  
  const arrayLoad = [
    imgHero
  ]
  
  return (
    <React.Fragment>
      <HeroProductsStatic 
        title="Get phygital with V-Commerce..." 
        img={imgHero}
        bgPosition="70% 100%"
        subtitle="...by joining the retail revolution and taking the first steps towards the fullest Full Reality shopping experience."
      >
      </HeroProductsStatic>
  
      
      <div className="side--quote-wrap extra--margin">
        <h6 className="md--title side--title">What is V-Commerce?</h6>
        <p className="preset-9 side--text">Become a pioneer in the new online shopping frontier by virtualizing the entire retail experience from product discovery to purchase.</p>
      </div>
      <div className="side--quote-wrap">
        <h6 className="md--title side--title">Own the Omnichannel experience</h6>
        <p className="preset-9 side--text">Design and build your ultimate shopping experience through Full Reality. Merge the best of online with brick and mortar to give your customers the opportunity to immerse themselves in your brand, interact with your products, and purchase in realtime.</p>
      </div>
      <div className="side--quote-wrap">
        <h6 className="md--title side--title">Feel the difference</h6>
        <p className="preset-9 side--text">We use advanced and patented technology to give your objects the truest-to-life look and feel in the environment of your design. The final result is a brand new shopping experience that goes beyond the limits of physical space to become easily accessible to anyone, anywhere.</p>
      </div>
      <NumbersWrap>
        <NumbersRowSingle
          extraMargin={true}
        >
          <NumberCell 
            isImage={false} 
            bigNumber="184" 
            size="B" 
            title="Dollar boost" 
            text="to global GDP from the use of VR and AR in the retail and consumer sector by 2030 (PwC)"
          />
          <NumberCell 
            isImage={false} 
            bigNumber="93" 
            size="%" 
            title="Of executives" 
            text="say they or their clients plan to increase their investment in VR and AR in the wake of COVID-19 (IDC)"
          />
        </NumbersRowSingle>
      </NumbersWrap>
      {
        !loader.isLoading &&
          <VideoScrollAlone
          idScroll="video-v-commerce"
          video={require('../../assets/video/video-end-v-commerce.mp4')} 
        />
      }
      
      <Banner  text="Intrigued? Let’s have a chat." route="/book-a-demo" copyRoute="Book a demo" />
      <Loader arrayLoad={arrayLoad}/>
    </React.Fragment>
  );
};

export default ProductsVCommerceContainer;
